import { useEffect, useRef, useState } from "preact/hooks";

// Only an unredeemed invite can move access into a different browser. Keep its token in the URL,
// never in browser storage, and offer this choice before the one-use redemption starts.
export function InviteBrowserHandoff({ onContinue }) {
  const [copy, setCopy] = useState("idle"); // idle | copied | manual
  const field = useRef(null);
  const inviteLink = location.href;
  useEffect(() => {
    if (copy === "manual") {
      field.current?.focus();
      field.current?.select();
    }
  }, [copy]);
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink);
      setCopy("copied");
    } catch {
      setCopy("manual"); // no clipboard API, or it rejected
    }
  };
  return (
    <div className="media-notice stack">
      {copy === "copied" ? <p role="status">Link copied</p> : copy === "manual" ? (
        <input ref={field} type="text" readOnly value={inviteLink} aria-label="Invite link" />
      ) : (
        <button type="button" className="primary-button" onClick={copyLink}>Copy invite link</button>
      )}
      <p className="muted">Continuing here uses this one-time invite. If this link has already been used, ask the person who invited you for a fresh private link to switch browsers. You can still continue with text only if this browser already has access.</p>
      <button type="button" className="text-button" onClick={onContinue}>Continue with text only</button>
    </div>
  );
}

// Shown when no service worker controls an authenticated page (DESIGN §5.1). Its URL cannot
// transfer the browser's session, and the original invitation may already have been used.
export function NoServiceWorkerBanner({ reason }) {
  return (
    <div className="media-notice" role="status">
      <p>{reason === "unsupported"
        ? "Photos and videos can’t open inside this app. To see them in your web browser, ask the person who invited you for a fresh private link and open it there."
        : "Your browser’s settings are blocking photos and videos on this page."}</p>
    </div>
  );
}
